import gql from 'graphql-tag';
import { query } from 'services/graphql';

export const risSearchQuery = gql`
  query risSearch($input: RisSearchInput) {
    risSearch(input: $input) {
      nodes {
        id
        lawName
        url
        date
        type
        risUrl
      }
      meta {
        totalCount
        count
        totalPages
        offset {
          page
          perPage
        }
      }
    }
  }
`;

export default query(risSearchQuery);
